import { ApiVersion } from '@flightctl/types';
import { ApiVersion as ImageBuilderApiVersion } from '@flightctl/types/imagebuilder';
import { ApiVersion as AlphaVersion } from '@flightctl/types/alpha';

export const PAGE_SIZE = 15;
export const EVENT_PAGE_SIZE = 200; // It's 500 in OCP console

// Class used to apply global styles to the application.
export const FLIGHTCTL_APP_CLASS = 'fctl-app';

export const CERTIFICATE_VALIDITY_IN_YEARS = 1;

export const getApiVersion = (
  api: 'flightctl' | 'imagebuilder' | 'alerts' | 'catalog' | 'vulnerability',
): string | undefined => {
  switch (api) {
    case 'flightctl':
      return ApiVersion.ApiVersionV1beta1;
    case 'catalog':
    case 'vulnerability':
      return AlphaVersion.ApiVersionV1alpha1;
    case 'imagebuilder':
      return ImageBuilderApiVersion.ApiVersionV1alpha1;
    case 'alerts':
    default:
      return undefined;
  }
};
